import { Typography } from 'antd';

interface ICountDownTimerProps {
	timeLeft: number;
}

const CountDownTimerOnScreen = (props: ICountDownTimerProps) => {
	const { timeLeft } = props;

	return (
		<Typography.Text
			style={{ color: 'white', fontWeight: 'bold', fontSize: '62px' }}>
			{timeLeft}
		</Typography.Text>
	);
};

export default CountDownTimerOnScreen;
